import { ScrollableDiv } from '@components/scrollable-div';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function RouteNotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <ScrollableDiv className="flex justify-center items-center">
      <Result
        status="404"
        title="404"
        subTitle="You seem to be lost in the void."
        extra={
          <Button type="primary" onClick={() => navigate('/analytics/ai-dashboard')}>
            {t('visit_reports')}
          </Button>
        }
      />
    </ScrollableDiv>
  );
}
